import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterFour";
import NavBar from "../components/NavbarTwo";
import TeamAreaGroup from "../components/TeamAreaGroup";

const Portfolio = () => {
  return (
    <>
      <SEO canonical="/portfolio" {...PAGES["/portfolio"]} />
      <NavBar />
      <Breadcrumb title="Our Portfolio" headingLevel="h1" />
      <TeamAreaGroup />
      <FooterOne />
    </>
  );
};

export default Portfolio;
